import { UnitTransferSignerRoleEnumType } from '__generated__/graphql';

export default function unitTransferSignerRoleToReadable(
  role: UnitTransferSignerRoleEnumType
): string {
  switch (role) {
    case UnitTransferSignerRoleEnumType.Transferor:
      return 'Transferor';
    case UnitTransferSignerRoleEnumType.Transferee:
      return 'Transferee';
    case UnitTransferSignerRoleEnumType.InvestmentManager:
      return 'AngelList India LLP (Investment Manager)';
    case UnitTransferSignerRoleEnumType.Trustee:
      return 'Vistra (Trustee)';
    default:
      return role;
  }
}
